export default "__VITE_PUBLIC_ASSET__3f1195be__"